import take from '../take.js';

export default function dropLast(n, xs) {
  return take(n < xs.length ? xs.length - n : 0, xs);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/ramda/es/internal/_dropLast.js
// module id = 1033
// module chunks = 0